import svg4everybody from 'svg4everybody'
import $ from 'jquery'

import './vendor/fullPage'

svg4everybody()

window.$ = $
window.jQuery = $
